export const INIT_STATE = {
    isLoading: false,
    listAccount: {}
}